import { render, staticRenderFns } from "./group.vue?vue&type=template&id=187aa684&scoped=true"
import script from "./group.vue?vue&type=script&setup=true&lang=js"
export * from "./group.vue?vue&type=script&setup=true&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=187aa684&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187aa684",
  null
  
)

export default component.exports